/**
 * TopPlayersMenu - Pantalla de selección de jugadores TOP
 * 501 Dart League Web
 * 
 * Pantalla intermedia entre TrainingMenu y el entrenamiento específico de cada jugador.
 * Muestra la lista de jugadores disponibles con su logo y nombre.
 */

import React from 'react';
import './styles/index.css';
import './styles/training.css';

const TOP_PLAYERS = [
  {
    id: 'jesus-salate',
    name: 'Jesús Salate',
    subtitle: '🇦🇷 Clasificado Mundial PDC Individual',
    logo: '/images/JesusSalate/logoJesus.png',
    badge: null,
    available: true,
  },
  {
    id: 'jaime-nunez',
    name: 'Jaime Núñez',
    subtitle: '101 en 6 dardos empezando en doble',
    logo: '/images/JaimeNunez/LogoJaime.png',
    badge: 'ACTUALIZADO',
    available: true,
  },
];

const TopPlayersMenu = ({ onBack, onSelectPlayer }) => {
  return (
    <div className="dart-league-dashboard training-menu-container">
      {/* Header */}
      <header className="training-menu-header">
        <div className="training-header-top">
          <button className="training-back-btn" onClick={onBack}>
            ← Volver
          </button>
        </div>
        <div className="training-header-icon">
          <img src="/Logo26.png" alt="501 Dart League" className="training-header-logo" />
        </div>
        <h1 className="training-menu-title">Jugadores TOP</h1>
        <p className="training-menu-subtitle">Reproduce el entrenamiento de los mejores jugadores</p>
      </header>

      {/* Player Cards */}
      <main className="top-players-grid">
        {TOP_PLAYERS.map((player) => (
          <button
            key={player.id}
            className={`top-player-card ${player.available ? 'active' : 'disabled'}`}
            onClick={() => player.available && onSelectPlayer(player.id)}
            disabled={!player.available}
          >
            <div className={`top-player-logo ${player.id === 'jaime-nunez' ? 'jaime-nunez-logo' : ''}`}>
              {player.logo ? (
                <img src={player.logo} alt={player.name} />
              ) : (
                <span className="top-player-lock">🔒</span>
              )}
            </div>
            <div className="top-player-info">
              <h3>{player.name}</h3>
              <p>{player.subtitle}</p>
            </div>
            <div className="top-player-badge-wrapper">
              {player.badge && (
                <span className={`training-option-badge ${player.available ? 'available' : 'coming-soon'}`}>
                  {player.badge}
                </span>
              )}
            </div>
            {player.available && <div className="training-option-arrow">→</div>}
          </button>
        ))}
      </main>
    </div>
  );
};

export default TopPlayersMenu;
